/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { Badge, Box, IconButton } from "@mui/material";
import { Notifications } from "@mui/icons-material";
import { useState } from "react";
import { selectNotifications } from "./notificationsSlice";
import NotificationsModal from "./NotificationsModal";
import { useAppSelector } from "../../app/hooks";
import { TechwiseNotification } from "../../utils/Interfaces";

const NotificationsBell = () => {
    const [open, setOpen] = useState<boolean>(false);

    const notifications: TechwiseNotification[] = useAppSelector(selectNotifications);

    return (
        <Box sx={{ mr: 1 }}>
            <NotificationsModal open={open} handleClose={() => setOpen(false)} />

            <IconButton onClick={() => setOpen(true)}>
                <Badge badgeContent={notifications.length} color="error">
                    <Notifications sx={{ color: "#FFFFFF" }} />
                </Badge>
            </IconButton>
        </Box>
    );
};

export default NotificationsBell;
